import React, { useCallback, useEffect, useState } from "react";
import { ControlForm, Modal, DragAndDropFile } from "../../components";
import {
  IAttachmentFile,
  ITaskCard,
  ITaskCardUpdateRequest
} from "../../models/Task";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import useAxios from "../../components/UseAxios/useAxios";
import TaskService from "../../services/api/task.service";
import { toggleMessage } from "../../components/Toast/Toast";
import UploadFileService from "../../services/api/uploadFile.service";
import { ITokenPayload } from "@/models/user";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import PayrollService from "../../services/api/payroll.service";

interface EditTaskAttachmentProps {
  open: boolean;
  onClose: () => void;
  onUpdateSuccess: () => void;
}

interface DataForm {
  files: File[];
}

const PayRollModal: React.FC<EditTaskAttachmentProps> = ({
  open,
  onClose,
  onUpdateSuccess
}) => {
  const [token, setToken] = useState<ITokenPayload>();
  const [isloaded, setIsLoaded] = useState(false);
  const updateAttachmentAxios = useAxios<ITaskCard>({ loading: "OnRequest" });
  const uploadFileAxios = useAxios<IAttachmentFile[]>({ loading: "OnRequest" });
  const deleteFileAxios = useAxios<string>({ loading: "OnRequest" });
  const [files, setFiles] = useState<IAttachmentFile[]>([]);
  const [filesDeleted, setFilesDeleted] = useState<File[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode<ITokenPayload>(token);

      setToken(decoded);
    }
  }, []);

  const onSubmit = useCallback((data: DataForm) => {
    handleUpdateTask(data.files);
  }, []);

  const handleUpdateTask = async (files: File[]) => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append("Files", file); // key phải trùng bên backend
    });
    const res = await PayrollService.create(formData);

    if (res.success) {
      toggleMessage({
        type: "success",
        message: res?.message ?? ""
      });
      onUpdateSuccess();
    } else {
      toggleMessage({
        type: "error",
        message: res?.message ?? ""
      });
    }
  };

  const onUploaded = (data: File[], name: string) => {
    setValue("files", data);
  };

  const handleRemoveFile = (value: File) => {
    const newFilesDeleted = [...filesDeleted];
    newFilesDeleted.push(value);
    setFilesDeleted(newFilesDeleted);
  };

  const validationSchema = Yup.object().shape({}) as any;

  const {
    handleSubmit,
    getValues,
    setValue,

    reset
  } = useForm<DataForm>({
    resolver: yupResolver(validationSchema)
  });

  useEffect(() => {
    if (open === true) {
      setFilesDeleted([]);
      setIsLoaded(true);
    }
    return () => {
      setIsLoaded(false);
      updateAttachmentAxios.reset();
      uploadFileAxios.reset();
      deleteFileAxios.reset();
    };
  }, [open]);

  return (
    <Modal
      title={t("Payroll.Modal.TitleCreate")}
      open={open}
      onClose={onClose}
      // loadingState={
      //   uploadFileAxios.isLoading ||
      //   deleteFileAxios.isLoading
      // }
      // disabledSubmit={
      //   uploadFileAxios.isLoading ||
      //   deleteFileAxios.isLoading
      // }
      onSubmit={handleSubmit(onSubmit)}
      textSubmit={t("Payroll.Modal.ButtonSend")}
      textClose={t("TaskUpdateModal.ButtonCancel")}
      width="580px"
    >
      {isloaded && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <ControlForm
            title={t("TaskUpdateModal.TitleAttachments")}
            infor={t("TaskUpdateModal.InfoAttachments")}
            classname="brand-form"
          >
            <DragAndDropFile
              title={t("TaskUpdateModal.TitleAttachments")}
              limitFile={200}
              onUploaded={onUploaded}
              name="attach"
              data={getValues("files")}
              handleRemoveFile={handleRemoveFile}
            />
          </ControlForm>
        </form>
      )}
    </Modal>
  );
};

export default PayRollModal;
